import React from 'react';
import {BrowserRouter as Router, Route, Routes, Navigate} from 'react-router-dom';
import {AuthProvider} from './context/AuthContext';
import {SwapMainAppProvider} from "./context/SwapMainAppContext";
import GatewayVerifier from './utils/GatewayTokenVerifier';
import AdminPortal from "./components/Admin/AdminPortal";
import RecaptchaProvider from "./utils/RecaptchaProvider";
import { HelmetProvider } from 'react-helmet-async';

import {getRpcCallCount} from "./configs/config";
const App = () => {
    console.log("Total RPC calls so far:", getRpcCallCount());
    return (
        <HelmetProvider>
            <SwapMainAppProvider>
                <AuthProvider>
                    <RecaptchaProvider>

                        <Router>
                            <Routes>
                                {/* Main route - handles both wallet and email login */}
                                <Route path="/*" element={<GatewayVerifier/>}/>

                                {/* Email login route with token */}
                                <Route path="/email" element={<GatewayVerifier/>}/>
                                <Route path="/admin" element={<AdminPortal/>}/>


                                {/* Catch all - redirect to home */}
                                <Route path="*" element={<Navigate to="/"/>}/>
                            </Routes>
                        </Router>
                    </RecaptchaProvider>

                </AuthProvider>
            </SwapMainAppProvider>
        </HelmetProvider>
    );
};

export default App;